import React from 'react';

export const SchemaContext = React.createContext({
  refreshKey: 0,
  refreshSchema: () => {}
});
